let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jaDFz")).then(() => parcelRequire('e1eeN'));